import React from "react";
import { Whatsapp } from "react-bootstrap-icons";
import "./footer.scss";

function WhatsAppFloat() {

  const phoneNumber = "918855947070"; // Add your WhatsApp number (without + sign)
  const message = "Hello, I want to know more about your services.";

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappURL}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Whatsapp size={28} />
    </a>
  );
}

export default WhatsAppFloat;
